export const meta = {
  title: '促销：自动生效的折扣',
  updatedAt: '2026-07-17',
  related: ['loyalty', 'broadcasts', 'pos'],
};

优惠券是一次发给一位顾客的；促销则是开一次、替您守在门口。促销生效期间，顾客一下单折扣就自动套用——不用输入任何代码，收银员也不需要记住什么。

## 两个模板

打开促销菜单下的**促销**页，点**新建促销**。目前提供两个模板：

- **按星期** —— 选一天或几天，例如*会员星期二：每逢星期二全天 8 折*。
- **欢乐时段（Happy Hour）** —— 每天固定时间窗，例如 _17:00–19:00，85 折_。

两者都需要一个名称（顾客会在自己的优惠旁看到它）、一个**整单百分比折扣**，以及有效期——默认从今天起三个月。促销一保存即刻生效。

坦白说明边界：今天表单里能创建的，都是对整单、所有门店、所有车型生效的百分比折扣。底层引擎其实懂得更多——最低消费、按门店定向、兑换上限、固定 RM 减免、免费加购——但控制台还没有设置这些的界面，所以目前无法配置。

## 折扣如何落地

折扣在顾客下单时计算，基于购物车小计（套餐加加购项），并显示为独立的一行优惠——顾客在自己的应用里看得到，收银员在 POS 付款页也能只读地看到。若同时有多个促销都符合条件，顾客只享受**最优惠的那一个**——促销之间不叠加，也不与优惠券叠加；省得最多的单个优惠胜出。

## 用 AI 起草

点**AI 起草**，用一句话描述您想要的——_“星期六早上欢乐时段，减 RM 5，早上 7 点到 10 点”_。助手会给出完整的促销草案：模板、折扣、有效期。在您审阅预览并点发布之前，什么都不会生效；不满意可以直接丢弃，不留痕迹。（这也是目前创建固定金额减免促销的唯一途径——手动表单只支持百分比。）如果网络的 AI 助手还没启用，面板会明说，不会瞎猜。

## 暂停、归档，以及数据

每一行促销都显示状态和来自真实工单的数字：被兑换了多少次、总共让利多少、最后一次生效是什么时候。活跃的促销随时可以暂停——折扣立即停止，之后还能恢复。归档则是永久退役；记录会保留，供您查账。

AI 助手还能起草一种常驻促销——手动表单暂不提供这种形式。
